import { Record } from 'immutable';

export const Practice = new Record({
  id: null,
  ordenId: null,
  nro: null,
  codigo: null,
  descripcion: null,
  desde: null,
  hasta: null,
  fecha_baja: null,
  motivo_baja: null,
  observaciones: null,
  cantidad: null,
  frecuencia: null,
  estado: null,
  asignada: null,
  orden: null,
  dtCreated: null,
  dtUpdated: null,
  dtDeleted: null,

});

export function createPractice(data) {
  return new Practice({
    id: data.id,
    ordenId: data.ordenId,
    nro: data.nro,
    codigo: data.codigo,
    descripcion: data.descripcion,
    desde: data.desde,
    hasta: data.hasta,
    fecha_baja: data.fechaBaja,
    motivo_baja: data.motivoBaja,
    observaciones: data.observaciones,
    cantidad: data.cantidad,
    frecuencia: data.frecuencia,
    estado: data.estado,
    asignada: data.asignada,
    orden: data.orden,
    dtCreated: data.dtCreated,
    dtUpdated: data.dtUpdated,
    dtDeleted: data.dtDeleted,
  });
}
